import { Table, TableItem, TableRow, Tag } from '@components';
import React from 'react';

interface UserRequestedLicensesProps {
  userRequestedLicenses: any[];
}

export const UserRequestedLicenseTable = ({
  userRequestedLicenses,
}: UserRequestedLicensesProps) => {
  const tableHeaders: object = ['Gevraagde licentie', 'Status'];

  return (
    <>
      {userRequestedLicenses?.length > 0 && (
        <div className="border-t dark:border-gray-700 mt-4">
          <Table header={tableHeaders}>
            {userRequestedLicenses.map((reqLic) => (
              <TableRow key={reqLic.id}>
                <TableItem type="tiny">{reqLic.lic_licentie}</TableItem>
                <TableItem type="tiny">
                  <Tag
                    style={
                      reqLic.status === 'pending'
                        ? 'lopende'
                        : reqLic.status === 'approved'
                          ? 'success'
                          : 'gesloten'
                    }
                    label={reqLic.status}
                  />
                </TableItem>
              </TableRow>
            ))}
          </Table>
        </div>
      )}
    </>
  );
};

export default UserRequestedLicenseTable;
